import React from 'react';

const Component = props => {
	return (
		<>
			<div className='my-[50px]'>
				<h2 className='text-[30px] md:text-[25px] font-normal mb-[30px] text-[#282e3f]'>Personal Experience</h2>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Passionné par son métier, Maître Jean-François GAILLY l'exerce volontiers et sans relâche depuis
					1980, année où il fut inscrit au barreau de Charleroi dès ses 22 ans.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Suivant les pas de deux grands-pères et d'un père avocats, il ne lui fut pas difficile de choisir sa
					voie professionnelle. Avec une touche nationale : après avoir obtenu son diplôme de licencié en
					droit à l'Université de Liège, il est allé perfectionner son néerlandais pendant un an à la KU
					Leuven.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Baigné dès le départ dans le droit des assurances, des responsabilités et des accidents de la
					circulation, il lui a été agréable d'étendre ses domaines de prédilection.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Fervent suiveur de cours de recyclage, Maître Jean-François GAILLY a autant de plaisir à donner des
					conseils qu'à s'investir dans des procédures où, de concert avec ses clients, et en collaboration
					intime avec les autres membres du cabinet, il aime aller au fond des choses dans l'intérêt des
					personnes qui le consultent.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Pendant de nombreuses années, il a dispensé des cours de droit au sein de l'IFAPME, enseignant
					particulièrement à des candidats courtiers en assurance ou détectives privés.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					En 2022, Maître Jean-François GAILLY s'est associé avec Maître Dimitri VAN WYMEERSCH initialement
					stagiaire, puis collaborateur, pour, forts de leur estime mutuelle et de leurs compétences
					complémentaires, fonder le cabinet d'avocats GAVA-<i>Lex</i>.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Jean-François GAILLY dispose d'un cabinet secondaire à 1170 Bruxelles (Watermael-Boitsfort),
					avenue des Coccinelles 104A ainsi qu'à 6280 Gerpinnes, rue Napoléon Anrys 5 où il peut aussi vous
					recevoir.
				</p>
			</div>
		</>
	);
};

export default Component;
